export const MAX_SCREEN_WIDTH = 1180
export const COMPANY_INFORMATION_FIELDS = [
  { dataKey: 'name', title: 'Company' },
  { dataKey: 'symbol', title: 'Symbol' },
  { dataKey: 'price', title: 'Expected Price' },
  { dataKey: 'date', title: 'Expected Date' },
  { dataKey: 'numberOfShares', title: 'Shares' },
  { dataKey: 'totalSharesValue', title: 'Volume' },
  { dataKey: 'status', title: 'Status' },
  { dataKey: 'exchange', title: 'Exchange' },
]
